import { useState, useEffect, useCallback } from 'react'

export function useCopyText(): [boolean, (text: string) => void] {
  const [isCopied, setIsCopied] = useState(false)

  const copyTextToClipboard = useCallback((text: string) => {
    if (window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => setIsCopied(true))
    } else {
      console.warn('navigator.clipboard inaccessible in http.')
    }
  }, [])

  useEffect(() => {
    if (!!isCopied) {
      setTimeout(() => setIsCopied(false), 2000)
    }
  })

  return [isCopied, copyTextToClipboard]
}
